import React from "react";
import { random } from "lodash";
import WantToReadButton from "../../want_to_read/want_to_read_button";
import ClickTrackingWrapper from "../../click_tracking_wrapper";
import { TRACKED_CLASSES_AUDIBLE } from "../../../modules/ads/click_tracking_helper";

import GrComponentFactory from "../../gr_component_factory";

export default GrComponentFactory.createClass({

  displayName: "AudiobookMobileSlide",

  propTypes: {
    bookId: React.PropTypes.string,
    title: React.PropTypes.string,
    imageUrl: React.PropTypes.string,
    bookUrl: React.PropTypes.string,
    author: React.PropTypes.object,
    description: React.PropTypes.object,
    avgRating: React.PropTypes.number,

    //properties passed to the children describing the behavior of
    //the parent
    carouselId: React.PropTypes.string,
    currentSlide: React.PropTypes.number,
    slideIndex: React.PropTypes.number,
    slidesToShow: React.PropTypes.number,
    sidesToScroll: React.PropTypes.number,
    slideCount: React.PropTypes.number,
    slideWidth: React.PropTypes.number,
  },

  getDefaultProps () {
    return {
      trackingOptions: {
        enableTracking: true,
      },
    };
  },
  

  renderImage() {
    const image =
        (<div className="gr-carousel-audiobookMobileBookCover">
          <a className="gr-carousel-audiobookMobileImgContainer" href={this.props.bookUrl}>
            <img src={this.props.imageUrl} />
          </a>
        </div>);
    return <ClickTrackingWrapper children={image} trackingOptions={TRACKED_CLASSES_AUDIBLE.AEP_Mobile_Carousel_BookImage} />;
  },

  renderTitle() {
    let bookName = this.props.title;
    if (bookName.length > 45) {
      bookName = `${bookName.substring(0, 43)  }...`;
    }
    const bookTitle = (<div className="gr-carousel-bookTitleMobile">
      <a href={this.props.bookUrl}>
        {bookName}
      </a>
    </div>);
    return <ClickTrackingWrapper children={bookTitle} trackingOptions={TRACKED_CLASSES_AUDIBLE.AEP_Mobile_Carousel_BookTitle} />;
  },

  renderAuthor() {
    const author = (<div className="gr-carousel-bookAuthorMobile">
      <a href={this.props.author.profileUrl}>
        by {this.props.author.name}
      </a>
    </div>);
    return <ClickTrackingWrapper children={author} trackingOptions={TRACKED_CLASSES_AUDIBLE.AEP_Mobile_Carousel_Author} />;
  },

  render () {

    const wantToReadProps = {
      bookId: this.props.bookId.toString(),
      bookTitle: this.props.title,
      uniqueId: random(1000000).toString(),
      showStars: false,
      showMenu: false,
      trackingOptions: TRACKED_CLASSES_AUDIBLE.AEP_Mobile_Carousel_WantToRead,
    };

    return (
        <div className="gr-carousel-audiobookMobileSlide">

          {this.renderImage()}
          <div className="gr-carousel-audiobookMobileBookDetails">
            {this.renderTitle()}
            {this.renderAuthor()}
            <div className="gr-carousel-wantToRead-SpacingLeftMobile">
              <WantToReadButton
                  {...wantToReadProps} />
            </div>
          </div>
        </div>
    );
  },
});
